import { IApplicationState } from '../../types/redux';

export function getIsEscrow(state: IApplicationState): boolean {
  return state.newbuilding.isEscrow || false;
}
